import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { formatPrice } from './utils';

// Ported one-to-one from @thd-olt-component-react/active-orders' LineItemPrice.tsx (OOP-4059) —
// see FulfillmentDetailsDrawer.tsx's doc comment.
export interface LineItemPriceProps {
  quantity?: number;
  netUnitPrice?: number;
  unitPrice?: number;
}

export const LineItemPrice: React.FC<LineItemPriceProps> = ({ quantity = 1, netUnitPrice, unitPrice }) => {
  const itemUnitPrice = (unitPrice === undefined ? netUnitPrice : unitPrice) ?? 0;

  if (quantity === 1) {
    return (
      <div className="sui-flex sui-flex-col" data-testid="line-item-price">
        {itemUnitPrice ? <Typography weight="bold">${formatPrice(itemUnitPrice)}</Typography> : null}
      </div>
    );
  }

  if (quantity > 1) {
    return (
      <div data-testid="line-item-price">
        <Typography weight="bold">${formatPrice(quantity * itemUnitPrice)}</Typography>
      </div>
    );
  }

  return null;
};
